import { Link } from "react-router-dom";
import { MapPin, Mail, Phone, ExternalLink } from "lucide-react";
import { SITE, NAV_LINKS, PEOPLE, GROUP_FIRMS } from "@/data/content";

export const Footer = () => (
  <footer className="noise-dark relative bg-brand-choc text-brand-cream">
    <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 pt-20 pb-10">
      <div className="grid gap-14 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <span className="inline-flex items-center rounded-xl bg-white/85 px-3 py-2 shadow-[0_0_28px_rgba(255,255,255,0.3)] ring-1 ring-white/60">
            <img src="images/nbs_logo_v2.png" alt="NBS National logo" className="h-16 w-auto" />
          </span>
          <p className="mt-6 max-w-sm text-brand-cream/70 leading-relaxed">
            From a single hand oven in 1961 to shelves across Africa and the Gulf — a third-generation
            family bakery from India.
          </p>
          <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.3em] text-brand-gold">{SITE.tagline}</p>
        </div>

        <div className="lg:col-span-2">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-brand-cream/50">Pages</p>
          <ul className="mt-5 space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`} className="text-sm text-brand-cream/80 hover:text-brand-gold transition-colors">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-3">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-brand-cream/50">Reach us</p>
          <ul className="mt-5 space-y-4 text-sm text-brand-cream/80">
            <li className="flex gap-3">
              <MapPin className="h-4 w-4 mt-0.5 shrink-0 text-brand-gold" />
              <span>{SITE.address}</span>
            </li>
            {PEOPLE.map((p) => (
              <li key={p.name} className="flex gap-3 items-center">
                <Phone className="h-4 w-4 shrink-0 text-brand-gold" />
                <span>
                  {p.name} — <a href={`tel:${p.tel}`} data-testid={`footer-phone-${p.name.split(" ")[0].toLowerCase()}`} className="hover:text-brand-gold transition-colors">{p.phone}</a>
                </span>
              </li>
            ))}
            <li className="flex gap-3 items-center">
              <Mail className="h-4 w-4 shrink-0 text-brand-gold" />
              <a href={`mailto:${SITE.email}`} data-testid="footer-email" className="hover:text-brand-gold transition-colors">{SITE.email}</a>
            </li>
          </ul>
        </div>

        <div className="lg:col-span-2">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-brand-cream/50">Group firms</p>
          <ul className="mt-5 space-y-3">
            {GROUP_FIRMS.map((g) => (
              <li key={g.name}>
                <a
                  href={g.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`footer-group-${g.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  className="group inline-flex items-center gap-1.5 text-sm text-brand-cream/80 hover:text-brand-gold transition-colors"
                >
                  {g.name}
                  <ExternalLink className="h-3 w-3 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="mt-16 overflow-hidden select-none" aria-hidden="true">
        <p className="font-display font-light text-brand-cream/10 leading-none text-[16.5vw] tracking-tight text-center whitespace-nowrap">
          NATIONAL
        </p>
      </div>

      <div className="mt-4 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-brand-cream/10 pt-6 text-[11px] text-brand-cream/50">
        <p>© {new Date().getFullYear()} {SITE.name}. All rights reserved.</p>
        <p className="font-mono uppercase tracking-[0.25em]">Made in India · Exported with pride</p>
      </div>
    </div>
  </footer>
);

export default Footer;
